import {
  INIT_BUYCART,
  ADD_CART,
  GET_USERINFO,
  RECORD_USERINFO,
  ADD_ANIMATION,
  SHOW_CART,
  REDUCE_CART,
  EDIT_CART,
  INIT_CATEGORY,
  INIT_EXTEND_04,
  INIT_EXTEND_05,
  INIT_EXTEND_06,
  INIT_EXTEND_07,
  INIT_EXTEND_08,
  INIT_EXTEND_09
} from './mutation-types'
import { setStore, getStore } from '../utils/storage'
import { getCartList, addCart, updCart, delCart, getAllExtend } from '/api/goods'
import { categoryList } from '/api/index'
export default {
  // 网页初始化时从本地缓存获取购物车数据
  [INIT_BUYCART] (state) {
    let params = {
      userId: getStore('userId')
    }
    getCartList(params).then(res => {
      if (res.errno === 0) {
        state.cartList = res.data.cartList
      }
    })
  },
  // 加入购物车
  [ADD_CART] (state, {userId, goodsId, goodsSn, goodsNum = 1}) {
    let params = {
      userId: userId,
      goodsId: goodsId,
      number: goodsNum,
      goodsSn: goodsSn
    }
    addCart(params).then(res => {
      state.cartList = res.data.cartList
    })
  },
  // 加入购物车动画
  [ADD_ANIMATION] (state, {moveShow, elLeft, elTop, img, cartPositionT, cartPositionL, receiveInCart}) {
    state.showMoveImg = moveShow
    if (elLeft) {
      state.elLeft = elLeft
      state.elTop = elTop
    }
    state.moveImgUrl = img
    state.receiveInCart = receiveInCart
    if (cartPositionT) {
      state.cartPositionT = cartPositionT
      state.cartPositionL = cartPositionL
    }
  },
  // 是否显示购物车
  [SHOW_CART] (state, {showCart}) {
    state.showCart = showCart
  },
  // 移除商品
  [REDUCE_CART] (state, {userId, goodsId}) {
    let params = {
      userId: userId,
      goodsId: goodsId
    }
    delCart(params).then(res => {
      state.cartList = res.data.cartList
    })
  },
  // 修改购物车
  [EDIT_CART] (state, {userId, goodsId, goodsNum, checked}) {
    let params = {
      userId: userId,
      goodsId: goodsId,
      number: goodsNum,
      checked: checked
    }
    updCart(params).then(res => {
      state.cartList = res.data.cartList
    })
  },
  // 记录用户信息
  [RECORD_USERINFO] (state, info) {
    state.userInfo = info
    state.login = true
    setStore('userInfo', info)
  },
  // 获取用户信息
  [GET_USERINFO] (state, info) {
    if (!state.userInfo) {
      return
    }
    if (!state.login) {
      return
    }
    if (!info.message) {
      state.userInfo = {...info}
    } else {
      state.userInfo = null
    }
  },
  [INIT_CATEGORY] (state) {
    let params = {
      userId: getStore('userId')
    }
    categoryList(params).then(res => {
      if (res.errno === 0) {
        state.categoryList = res.data.categoryList
      }
    })
  },
  [INIT_EXTEND_04] (state) {
    let params = {
      params: {
        topicId: 4
      }
    }
    getAllExtend(params).then(res => {
      if (res.errno === 0) {
        state.extend04List = res.data.extend.dataList
      }
    })
  },
  [INIT_EXTEND_05] (state) {
    let params = {
      params: {
        topicId: 5
      }
    }
    getAllExtend(params).then(res => {
      if (res.errno === 0) {
        state.extend05List = res.data.extend.dataList
      }
    })
  },
  [INIT_EXTEND_06] (state) {
    let params = {
      params: {
        topicId: 6
      }
    }
    getAllExtend(params).then(res => {
      if (res.errno === 0) {
        state.extend06List = res.data.extend.dataList
      }
    })
  },
  [INIT_EXTEND_07] (state) {
    let params = {
      params: {
        topicId: 7
      }
    }
    getAllExtend(params).then(res => {
      if (res.errno === 0) {
        state.extend07List = res.data.extend.dataList
      }
    })
  },
  [INIT_EXTEND_08] (state) {
    let params = {
      params: {
        topicId: 8
      }
    }
    getAllExtend(params).then(res => {
      if (res.errno === 0) {
        state.extend08List = res.data.extend.dataList
      }
    })
  },
  [INIT_EXTEND_09] (state) {
    let params = {
      params: {
        topicId: 9
      }
    }
    getAllExtend(params).then(res => {
      if (res.errno === 0) {
        state.extend09List = res.data.extend.dataList
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js